import classNames from 'classnames/bind';

export default function PostSidebar({className, children}) {
  return (
    <div className={classNames(className)}>
      {children}
    </div>
  );
};
